import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';
import { SuccessIcon } from '@lt/components/icons-react/auth';
import { i18n } from '@lt/localization';

type Props = {
  label?: ReactNode;
};

export const AuthSuccess = ({
  label = i18n.t('checkout.authSuccess'),
}: Props) => (
  <Wrapper>
    <SuccessIcon width={24} height={24} />
    {label}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0 24px;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #17181a;
`;
